import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import Cadastro from "../../../componentes/Cadastro";
import { Column } from "../../../lib_react_adminlte/componentes/Table";
import Api from "../../../utils/Api";
import LabeledInput from "../../../lib_react_adminlte/componentes/LabeledInput";
import ImageInput from "../../../lib_react_adminlte/componentes/ImageInput";
import Box from "../../../lib_react_adminlte/componentes/Box.jsx";

const codigo_tela = "003";

// função principal
function Empresa({ usuario, empresa }) {
  // state da tela
  const [id_pk, setId_pk] = useState("");
  const [nome_fantasia, setNome_fantasia] = useState("");
  const [razao_social, setRazao_social] = useState("");
  const [doc_federal, setDoc_federal] = useState("");
  const [doc_estadual, setDoc_estadual] = useState("");
  const [cep, setCep] = useState("");
  const [endereco, setEndereco] = useState("");
  const [numero, setNumero] = useState("");
  const [complemento, setComplemento] = useState("");
  const [email, setEmail] = useState("");
  const [telefone_1, setTelefone_1] = useState("");
  const [telefone_2, setTelefone_2] = useState("");
  const [telefone_3, setTelefone_3] = useState("");
  const [img_inicio, setImg_inicio] = useState("");
  const [img_logo, setImg_logo] = useState("");
  const [img_capa, setImg_capa] = useState("");
  const [hash, setHash] = useState("");
  const [images, setImages] = useState([]);

  const [itemSelecionado, setItemSelecionado] = useState([]);
  // declaração da referencia que será utilizada logo abaixo
  const cadastroRef = useRef({});

  // função que executa sempre que entramos na tela, ou se colocarmos entre [] uma variável, ele vai executar o useEffect sempre que existir uma alteração nessa variável.
  useEffect(() => { }, []);

  // renderizando as colunas
  function renderColunas() {
    return [
      <Column
        key={1}
        style={{ width: "25%" }}
        field="nome_fantasia"
        header="Nome Empresa"
      />,
      <Column
        key={2}
        style={{ width: "25%" }}
        field="razao_social"
        header="Razão Social"
      />,
      <Column
        key={3}
        style={{ width: "25%" }}
        field="doc_federal"
        header="Documento Federal"
      />,
      <Column
        key={4}
        style={{ width: "25%" }}
        field="doc_estadual"
        header="Documento Estadual"
      />,
    ];
  }

  // função que retorna os registros
  async function getRegistros(filtro) {
    const ret = await Api.buscar("tab_empresa", filtro, "");
    return ret;
  }

  // renderiza o formulário da tela
  function renderForm() {
    return (
      <div>
        <div className="row mt-5">
          <div className="col-sm-3">
            <LabeledInput
              label="Nome Fantasia (*):"
              placeholder="Nome Fantasia"
              value={nome_fantasia}
              onChange={(e) => {
                setNome_fantasia(e.target.value.toUpperCase());
              }}
            />
          </div>
          <div className="col-sm-3">
            <LabeledInput
              label="Razão Social (*):"
              placeholder="Razão Social"
              value={razao_social}
              onChange={(e) => {
                setRazao_social(e.target.value.toUpperCase());
              }}
            />
          </div>
          <div className="col-sm-3">
            <LabeledInput
              label="Documento Federal (*):"
              placeholder="Documento Federal"
              value={doc_federal}
              onChange={(e) => {
                setDoc_federal(e.target.value.toUpperCase());
              }}
            />
          </div>
          <div className="col-sm-3">
            <LabeledInput
              label="Documento Estadual (*):"
              placeholder="Documento Estadual"
              value={doc_estadual}
              onChange={(e) => {
                setDoc_estadual(e.target.value.toUpperCase());
              }}
            />
          </div>
        </div>

        <div className="row mt-5">
          <div className="col-sm-1">
            <LabeledInput
              label="Cep (*):"
              placeholder="Cep"
              value={cep}
              onChange={(e) => {
                setCep(e.target.value.toUpperCase());
              }}
            />
          </div>
          <div className="col-sm-3">
            <LabeledInput
              label="Endereço (*):"
              placeholder="Endereço"
              value={endereco}
              onChange={(e) => {
                setEndereco(e.target.value.toUpperCase());
              }}
            />
          </div>
          <div className="col-sm-1">
            <LabeledInput
              label="Numero (*):"
              placeholder="Numero"
              value={numero}
              onChange={(e) => {
                setNumero(e.target.value.toUpperCase());
              }}
            />
          </div>
          <div className="col-sm-2">
            <LabeledInput
              label="Complemento (*):"
              placeholder="Complemento"
              value={complemento}
              onChange={(e) => {
                setComplemento(e.target.value.toUpperCase());
              }}
            />
          </div>
        </div>

        <div className="row mt-5">
          <div className="col-sm-2">
            <LabeledInput
              label="E-mail:"
              placeholder="E-mail"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value.toUpperCase());
              }}
            />
          </div>
          <div className="col-sm-2">
            <LabeledInput
              label="Telefone 1 (*):"
              placeholder="Telefone 1"
              value={telefone_1}
              onChange={(e) => {
                setTelefone_1(e.target.value.toUpperCase());
              }}
            />
          </div>
          <div className="col-sm-2">
            <LabeledInput
              label="Telefone 2:"
              placeholder="Telefone 2"
              value={telefone_2}
              onChange={(e) => {
                setTelefone_2(e.target.value.toUpperCase());
              }}
            />
          </div>
          <div className="col-sm-2">
            <LabeledInput
              label="Telefone 3:"
              placeholder="Telefone 3"
              value={telefone_3}
              onChange={(e) => {
                setTelefone_3(e.target.value.toUpperCase());
              }}
            />
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-sm-4">
            <LabeledInput
              label="Hash:"
              placeholder="Hash"
              value={hash}
              onChange={(e) => {
                setHash(e.target.value.toUpperCase());
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  function renderFormConfiguracoes() {
    return (
      <div>
        {/* <Box title="CONFIG WEB" collapsible>
          <div className="row">
            {/*  */}
        {/* <div className="col-sm-2">
              <ImageInput
                label="Início"
                image={img_inicio}
                field="img_inicio"
                onChange={({ field, image, file }) => {
                  if (images)
                    setImages([...images, { image: image, field: field }]);
                  else setImages([{ image: image, field: field }]);
                  setImg_inicio(image);
                }}
              />
            </div>
            <div className="col-sm-2">
              <ImageInput
                label="Logo"
                image={img_logo}
                field="img_logo"
                onChange={async ({ field, image, file }) => {
                  if (images)
                    setImages([...images, { image: image, field: field }]);
                  else setImages([{ image: image, field: field }]);
                  setImg_logo(image);
                }}
              />
            </div>
            <div className="col-sm-2">
              <ImageInput
                label="Capa"
                image={img_capa}
                field="img_capa"
                onChange={({ field, image, file }) => {
                  if (images)
                    setImages([...images, { image: image, field: field }]);
                  else setImages([{ image: image, field: field }]);
                  setImg_capa(image);
                }}
              />
            </div>
          </div> */}
        {/* </Box>  */}
      </div>
    );
  }

  function getDadosConfiguracoes() {
    return {};
  }

  //retorna a mensagem de excluir
  function getMsgExcluir() {
    return "Tem certeza que deseja excluir " + nome_fantasia + " ?";
  }

  //
  function getRegistro() {
    return {
      id_pk: id_pk,
      id_pk_usuario: usuario.id_pk,
      nome_fantasia: nome_fantasia,
      razao_social: razao_social,
      doc_federal: doc_federal,
      doc_estadual: doc_estadual,
      cep: cep,
      endereco: endereco,
      numero: numero,
      complemento: complemento,
      email: email,
      telefone_1: telefone_1,
      telefone_2: telefone_2,
      telefone_3: telefone_3,
      img_inicio: img_inicio,
      img_logo: img_logo,
      img_capa: img_capa,
      images: images,
      hash: hash,
    };
  }

  function setRegistro(item) {
    setId_pk(item.id_pk);
    setNome_fantasia(item.nome_fantasia);
    setRazao_social(item.razao_social);
    setDoc_federal(item.doc_federal);
    setDoc_estadual(item.doc_estadual);
    setCep(item.cep);
    setEndereco(item.endereco);
    setNumero(item.numero);
    setComplemento(item.complemento);
    setEmail(item.email);
    setTelefone_1(item.telefone_1);
    setTelefone_2(item.telefone_2);
    setTelefone_3(item.telefone_3);
    setImg_capa(item.img_capa);
    setImg_logo(item.img_logo);
    setImg_inicio(item.img_inicio);
    setImages(item.images);
    setHash(item.hash);
  }

  function limparRegistro() {
    setId_pk("");
    setRazao_social("");
    setNome_fantasia("");
    setDoc_federal("");
    setDoc_estadual("");
    setCep("");
    setEndereco("");
    setNumero("");
    setComplemento("");
    setEmail("");
    setTelefone_1("");
    setTelefone_2("");
    setTelefone_3("");
    setImg_capa("");
    setImg_logo("");
    setImg_inicio("");
    setImages([]);
    setHash("");
  }

  return (
    <div>
      <Cadastro
        tabela="tab_empresa"
        pk="id_pk"
        titulo="Cadastro de Empresa"
        renderForm={renderForm}
        renderColunas={renderColunas}
        getMsgExcluir={getMsgExcluir}
        getRegistros={getRegistros}
        getRegistro={getRegistro}
        setRegistro={setRegistro}
        limparRegistro={limparRegistro}
        onDoubleClick={itemSelecionado}
        itemSelecionadoTable={itemSelecionado}
        onSelecionarItemTable={(e) => setItemSelecionado(e)}
        ref={cadastroRef}
        getDadosConfiguracoes={getDadosConfiguracoes}
        renderFormConfiguracoes={renderFormConfiguracoes}
        tableSelecionavel
        codigo_tela={codigo_tela}
        editConfig
      />
    </div>
  );
}

export default connect((state) => ({
  usuario: state.usuario,
  empresa: state.empresa,
}))(Empresa);



// WEBPACK FOOTER //
// ./src/telas/Cadastros/Empresa/index.jsx